import { createContext, useContext } from 'react'
import { Reservation } from 'src/types/reservation'

const ReservationCardContext = createContext<Reservation | null>(null)

export const ReservationCardProvider = ReservationCardContext.Provider
export const useReservationCardContext = () =>
  useContext(ReservationCardContext) as Reservation
